// extracted by mini-css-extract-plugin
export var body = "_br-5";
export var closeButton = "_br-f";
export var container = "_br-1";
export var content = "_br-2";
export var cta = "_br-c";
export var ctaLabel = "_br-b";
export var eyebrow = "_br-3";
export var howTo = "_br-6";
export var image = "_br-e";
export var modal = "_br-0";
export var socialButton = "_br-d";
export var stepCard = "_br-8";
export var stepLabel = "_br-a";
export var stepNumber = "_br-9";
export var steps = "_br-7";
export var title = "_br-4";